export default "__VITE_ASSET__DXHPv85___"